import { render, staticRenderFns } from "./bgs-documents.vue?vue&type=template&id=2140a486"
import script from "./bgs-documents.vue?vue&type=script&lang=js"
export * from "./bgs-documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports